import React from "react";
import { arrayOf, bool, func, node, oneOfType, string } from "prop-types";

import { MenuPopupCaret, MenuPopupContent } from "./styled";

const MenuPopup = props => (
  <MenuPopupContent {...props}>
    <MenuPopupCaret />
    {props.children}
  </MenuPopupContent>
);

MenuPopup.defaultProps = {
  isActive: false
};

MenuPopup.propTypes = {
  /** Children is required for this component. There can be any content. */
  children: oneOfType([node, string, arrayOf(node)]).isRequired,
  /** Whether the popover is active */
  isActive: oneOfType([bool, func])
};

export default MenuPopup;
